import { useSelector } from 'react-redux'
import useWindowDimensions from '../../utils/hooks/useWindowDimensions'
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'

const useLnbHeight = () => {
  const { isExpanded, isOver } = useSelector(state => state.lnb)
  const { height: windowHeight } = useWindowDimensions()
  const accountRef = useRef()
  const [accountHeight, setAccountHeight] = useState(0)
  const menuRef = useRef()
  const [menuHeight, setMenuHeight] = useState(0)
  const updateMenuHeight = useCallback(() => {
    if (windowHeight) {
      const otherHeight = isExpanded
        ? accountHeight + 232
        : isOver
        ? accountHeight + 152
        : 133
      setMenuHeight(document.documentElement.clientHeight - otherHeight)
    }
  }, [windowHeight, accountHeight, isExpanded, isOver])
  useLayoutEffect(() => updateMenuHeight(), [updateMenuHeight])
  useEffect(() => {
    const accountObserver = new IntersectionObserver(entries => {
      const entry = entries.find(({ isIntersecting }) => isIntersecting)
      const height = entry?.boundingClientRect.height || 0
      if (height > 0) {
        setAccountHeight(height)
      }
    })
    if (accountRef.current) {
      accountObserver.observe(accountRef.current)
    }
    return () => accountObserver.disconnect()
  }, [menuRef, updateMenuHeight])
  useEffect(() => {
    const menuObserver = new MutationObserver(() => {
      updateMenuHeight()
    })
    if (menuRef.current) {
      menuObserver.observe(menuRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
      })
    }
    return () => menuObserver.disconnect()
  }, [menuRef, updateMenuHeight])
  return {
    accountRef,
    menuRef,
    menuHeight,
  }
}
export default useLnbHeight
